export default __webpack_public_path__ + "static/media/photo--sm--misc-2.d0046da9.jpg";